
































import Vue from 'vue';
import { AuthStore } from '@kasasa/fbase-components/lib';
import { mapState } from 'vuex';
import { Component, Prop, Watch } from 'vue-property-decorator';
import { Fi } from '@/api/fi/Fi';

@Component({
  computed: {
    ...mapState(['auth']),
  },
})
export default class FIMultiSelector extends Vue {
	@Prop() readonly value!: number[]|Fi[];

	@Prop() readonly color!: string;

	@Prop({ default: false }) readonly hideDetails!: boolean;

	@Prop({ default: 'Select an FI' }) readonly label!: string;

	@Prop({ default: true }) readonly dense!: boolean;

	@Prop({ default: true }) readonly includeKasasaFi!: boolean;

	auth!: AuthStore;

	allFis: Fi[] = [];

	selected: Fi[] = [];

	mounted() {
	  this.getFis();
	  this.onExternalValueChanged();
	}

	@Watch('auth', { deep: true })
	getFis() {
	  if (this.auth && this.auth.headerData) {
	    this.allFis = this.auth.headerData.fis;
	  }
	}

	@Watch('value')
	onExternalValueChanged() {
	  if (FIMultiSelector.isArrayOfNumbers(this.value)) {
	    // Value is the fi id, so select the one with that id, if found
	    const foundFis : Fi[] = [];
	    for (let valIndex = 0; valIndex < this.value.length; valIndex++) {
	      const value = this.value[valIndex];
	      for (let fiIndex = 0; fiIndex < this.allFis.length; fiIndex++) {
	        if (Number(this.allFis[fiIndex].fiId) === value) {
	          foundFis.push(this.allFis[fiIndex]);
	        }
	      }
	    }
	    this.selected = foundFis;
	  } else if (this.value) {
	    // Otherwise assume that we've been provided the actual selected fi object Array
	    const selected = this.value as unknown;
	    this.selected = selected as Fi[];
	  } else {
	    this.selected = [];
	  }
	}

	static isArrayOfNumbers(obj: any) {
	  if (!obj || !Array.isArray(obj)) {
	    return false;
	  }

	  const arrayRef = obj as Array<any>;
	  if (arrayRef.length === 0) {
	    return false;
	  }

	  return typeof arrayRef[0] === 'number';
	}

	get computedFis() {
	  if (this.allFis) {
	    // Filter 'bad' fis without proper ids, except the default "Kasasa"
	    const list = this.allFis.filter(
	      (fi: Fi) => (this.includeKasasaFi && fi.name === 'Kasasa') || (fi.fiId && fi.fiId > 0),
	    );

	    list.sort((a: Fi, b: Fi) => {
	      if (!a.fiId || Number.isNaN(a.fiId)) {
	        return -1;
	      }
	      if (!b.fiId || Number.isNaN(b.fiId)) {
	        return 1;
	      }
	      return a.fiId - b.fiId;
	    });

	    return list;
	  }

	  return [];
	}

	displayName(fi: Fi): string {
	  return this.formatDisplayName(fi, false);
	}

	captionDisplayName(fi: Fi): string {
	  return this.formatDisplayName(fi, true);
	}

	updateSelection(newValue: Fi[]) {
	  this.selected = newValue;
	  this.$emit('input', this.selected);
	}

	formatDisplayName(fi: Fi, isCaption: boolean = false): string {
	  let name = '';
	  if (fi) {
	    if (!fi.fiId || !this.isNumeric(fi.fiId)) {
	      name = fi.name;
	    } else {
	      name = `${fi.name} - ${fi.fiId}`;
	    }
	  }
	  return name;
	}

	isNumeric = (value: any) => !Number.isNaN(value)
}
